<template>
    <div></div>
</template>
<script>
export default {
  props: {
    sampleId: {
      type: String,
      default: ''
    },
    currentSampleId: {
      type: String,
      default: ''
    },
    labOrderId: {
      type: String,
      default: ''
    },
    isAgentOrder: {
      type: Boolean,
      default: false
    }
  },
  created () {
    // 实验室订单的重采订单
    // if (this.isAgentOrder) {
    this.$router.push(`/lab-order-form/true/${this.labOrderId}?recollect=true`)
    // } else {
    // 商城订单的重采订单
    // this.$router.push('/waiting-for-sample-recollect/sample-recollect-detail/' + this.currentSampleId)
    // }
  }
}
</script>
